"use strict";

module.exports = {
  purple1: "#855279",
  purple2: "#B575BB",
  purple3: "#DABADD",
  yellow1: "#AC8E4C",
  yellow2: "#FFD373",
  yellow3: "#F0DFBC",
  peach1: "#AE6E52",
  peach2: "#F79C75",
  peach3: "#F1CEBF",
  blue1: "#1B6383",
  blue2: "#268CBA",
  blue3: "#A1C8DA",
  teal1: "#178287",
  teal2: "#19A4AB",
  teal3: "#9CD1D4",
  teal4: "#D1EDEE",
  gray1: "#393939",
  gray2: "#828282",
  gray3: "#DCDCDC",
  gray4: "#ECECEC"
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbG9ycy5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwicHVycGxlMSIsInB1cnBsZTIiLCJwdXJwbGUzIiwieWVsbG93MSIsInllbGxvdzIiLCJ5ZWxsb3czIiwicGVhY2gxIiwicGVhY2gyIiwicGVhY2gzIiwiYmx1ZTEiLCJibHVlMiIsImJsdWUzIiwidGVhbDEiLCJ0ZWFsMiIsInRlYWwzIiwidGVhbDQiLCJncmF5MSIsImdyYXkyIiwiZ3JheTMiLCJncmF5NCJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsTUFBQUEsQ0FBT0MsT0FBUEQsR0FBaUI7QUFDZkUsRUFBQUEsT0FBQUEsRUFBUyxTQURNO0FBRWZDLEVBQUFBLE9BQUFBLEVBQVMsU0FGTTtBQUdmQyxFQUFBQSxPQUFBQSxFQUFTLFNBSE07QUFJZkMsRUFBQUEsT0FBQUEsRUFBUyxTQUpNO0FBS2ZDLEVBQUFBLE9BQUFBLEVBQVMsU0FMTTtBQU1mQyxFQUFBQSxPQUFBQSxFQUFTLFNBTk07QUFPZkMsRUFBQUEsTUFBQUEsRUFBUSxTQVBPO0FBUWZDLEVBQUFBLE1BQUFBLEVBQVEsU0FSTztBQVNmQyxFQUFBQSxNQUFBQSxFQUFRLFNBVE87QUFVZkMsRUFBQUEsS0FBQUEsRUFBTyxTQVZRO0FBV2ZDLEVBQUFBLEtBQUFBLEVBQU8sU0FYUTtBQVlmQyxFQUFBQSxLQUFBQSxFQUFPLFNBWlE7QUFhZkMsRUFBQUEsS0FBQUEsRUFBTyxTQWJRO0FBY2ZDLEVBQUFBLEtBQUFBLEVBQU8sU0FkUTtBQWVmQyxFQUFBQSxLQUFBQSxFQUFPLFNBZlE7QUFnQmZDLEVBQUFBLEtBQUFBLEVBQU8sU0FoQlE7QUFpQmZDLEVBQUFBLEtBQUFBLEVBQU8sU0FqQlE7QUFrQmZDLEVBQUFBLEtBQUFBLEVBQU8sU0FsQlE7QUFtQmZDLEVBQUFBLEtBQUFBLEVBQU8sU0FuQlE7QUFvQmZDLEVBQUFBLEtBQUFBLEVBQU87QUFwQlEsQ0FBakJyQiJ9